export default "__VITE_ASSET__DuCetYQO__"